import { Filters, FilterConfig } from '../../../types';

function capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const generatePaginationQueryParams = (pageNumber: Filters['pageNumber'], pageSize: Filters['pageSize']) => {
    return `$skip=${pageNumber * pageSize}&$top=${pageSize}&$count=true`;
};

export const generateOrderByQueryParams = (sorted: Filters['sorted'], showDefault = true) => {
    const orderBySeparator = '&$orderby=';
    const defaultSorting = `LastUpdatedAt desc`;

    if (sorted) {
        const sorting = `${capitalizeFirstLetter(sorted.columnId)} ${sorted.direction}`;
        return showDefault ? `${orderBySeparator}${sorting}, ${defaultSorting}` : `${orderBySeparator}${sorting}`;
    }

    return showDefault ? `${orderBySeparator}${defaultSorting}` : '';
};
/**
 * Example of configuration for user management filters.
 *   const filterConfig: FilterConfig<UserManagementFilters> = {
 *       name: (value) => `(contains(firstName, '${value}') or contains(lastName, '${value}'))`,
 *       status: (value) => `status eq '${value}'`,
 *       state: (value) => `isLocked eq ${value}`,
 *       drugShortNames: (values) => values.map(value => `drugShortName eq '${value}'`).join(' or ')
 *   };
 */
export const generateFilterQuery = (filters: Filters, config: FilterConfig) => {
    const queryParams: string[] = [];

    for (const key in filters) {
        const value = filters[key];

        if (
            (Array.isArray(value) && value.length > 0) ||
            (!Array.isArray(value) &&
                value !== null &&
                value !== undefined &&
                value !== '' &&
                value !== 'none' &&
                config[key])
        ) {
            queryParams.push(config[key](value));
        }
    }

    return queryParams.length > 0 ? `$filter=${queryParams.join(' and ')}&` : '';
};
